<template>
  <div class="dashboard-form-export">
    <h2>Export your form data</h2>

    <p>
      Download a CSV file that can be imported into a variety of apps and services.
    </p>

    <div>
      <md-button class="md-raised md-primary" @click="exportXlsx" :disabled="disabled">Export XLSX ({{this.submissions.length}} submissions)</md-button>
      <md-button class="md-raised md-primary" @click="exportCsv" :disabled="disabled">Export CSV ({{this.submissions.length}} submissions)</md-button>
    </div>

  </div>
</template>

<script>
import SheetExporter from '../../models/SheetExporter'

export default {
  name: 'DashboardFormExport',
  computed: {
    base_url_form () {
      return this.$store.getters['base_url_form']
    },
    form () {
      return this.$store.getters['currentForm']
    },
    submissions () {
      return this.form.submissions
    },
    submissionsContent () {
      const that = this
      return this.submissions.map((submission) => {
        let content = JSON.parse(JSON.stringify(submission.content))
        for (let file of (submission.files || [])) {
          content[`File_${file.fieldName}`] = that.makeDownloadUrl(file)
        }
        content.created_at = submission.created_at
        return content
      })
    },
    disabled () {
      return this.submissions.length === 0
    }
  },
  methods: {
    makeDownloadUrl (file) {
      return `${this.base_url_form}/files/${file.token}`
    },
    export (exportFormat) {
      const sheetExporter = new SheetExporter(this.submissionsContent)
      sheetExporter.export(exportFormat, `Export_${this.form.name}`)
    },
    exportXlsx () {
      this.export('xlsx')
    },
    exportCsv () {
      this.export('csv')
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-button {
    margin-left: 0;
    margin-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormExport.vue